import { cloneDeep, isEqual } from "lodash";
import { get } from "svelte/store";

export class ListStore {
  constructor(template, listStore, selectedStore) {
    this.entityTemplate = template;
    this.listStore = listStore;
    this.selectedStore = selectedStore;
    this.resetSelected();
  }

  resetSelected() {
    this.selectedStore.set(cloneDeep(get(this.entityTemplate)));
  }

  select(entity) {
    this.selectedStore.set(cloneDeep(entity));
  }

  upsertSelected() {
    const selected = get(this.selectedStore);
    if (selected.id) {
      this._update(selected);
    } else {
      this._add(selected);
    }
  }

  deleteSelected() {
    const list = get(this.listStore).filter(
      (element) => element.id !== get(this.selectedStore).id
    );
    this.listStore.set(list);
    this.resetSelected();
  }

  selectedWasUpdated() {
    const selected = get(this.selectedStore);
    if (selected.id) {
      const original = get(this.listStore).find(
        (element) => element.id === selected.id
      );
      return !isEqual(selected, original);
    } else {
      return !isEqual(selected, get(this.entityTemplate));
    }
  }

  _add(entity) {
    const list = [...get(this.listStore)];
    const idList = list.map((elem) => elem.id);
    let newId = Math.max(0, ...idList);
    entity.id = newId + 1;
    list.push(entity);
    this.listStore.set(list);
    this.resetSelected();
  }

  _update(entity) {
    const list = [...get(this.listStore)];
    let listIndex = list.findIndex((element) => element.id === entity.id);
    list[listIndex] = entity;
    this.listStore.set(list);
  }
}
